'use strict';

(function ($window, initEvent, mutationConfig, mutationCallback) {
    var observer = new MutationObserver(mutationCallback);

    $window.addEventListener(initEvent, function ($event) {
        return observer.observe($window.document.body, $event.detail ? $event.detail : mutationConfig);
    });
})(window, 'initialise-mutation-observation', {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true
}, function (mutations) {
    var mappedMutation = mutations.map(function (mutation) {
        return {
            nodesAdded: mutation.addedNodes && mutation.addedNodes.length > 0,
            nodesRemoved: mutation.removedNodes && mutation.removedNodes.length > 0,
            attributeChange: mutation.type === 'attributes',
            mutation: mutation
        };
    });
    var mutationEvent = new CustomEvent('dom-mutated', { detail: mappedMutation });
    window.dispatchEvent(mutationEvent);
});

(function ($window, initVars, mutationChecker) {
    $window.addEventListener('initialise-mutation-observer', function ($event) {
        if ($event.detail) {
            initVars.push($event.detail);
            if (initVars && initVars.length === 1) {
                $window.dispatchEvent(new CustomEvent('initialise-mutation-observation'));
                $window.addEventListener('dom-mutated', function ($event) {
                    return mutationChecker($window, $event.detail, initVars);
                });
            }
        }
    });
})(window, [], function ($window, mutations, initVars) {
    var matchedMutation = {};
    var hasMatchedMutations = false;
    mutations.forEach(function (mutation) {
        initVars.forEach(function (initVar) {
            var nodesAdded = [];
            var nodesRemoved = [];
            var attributesChanged = [];

            if (mutation.nodesRemoved) {
                nodesRemoved.concat(mutation.mutation.removedNodes);
                hasMatchedMutations = true;
            }
            if (mutation.nodesAdded) {
                if (mutation.mutation.addedNodes && mutation.mutation.addedNodes.forEach) {
                    mutation.mutation.addedNodes.forEach(function (element) {
                        if (element.classList && element.classList.contains(initVar.class) || element.hasAttribute && element.hasAttribute(initVar.attribute) || element.id && element.id === initVar.id) {
                            nodesAdded.push(element);
                            hasMatchedMutations = true;
                        }

                        if (element.querySelectorAll) {
                            var internalClasses = element.getElementsByClassName(initVar.class);
                            var internalAttrs = element.querySelectorAll('[' + initVar.attribute + ']');
                            var internalIds = element.querySelectorAll('#' + initVar.id);

                            if (internalClasses.length > 0 || internalAttrs.length > 0 || internalIds.length > 0) {
                                nodesAdded = nodesAdded.concat([].slice.call(internalClasses));
                                nodesAdded = nodesAdded.concat([].slice.call(internalAttrs));
                                nodesAdded = nodesAdded.concat([].slice.call(internalIds));

                                hasMatchedMutations = true;
                            }
                        }
                    });
                }
            }
            if (mutation.attributeChange && mutation.mutation.attributeName === initVar.attribute) {
                attributesChanged.push(mutation.mutation.target);
                hasMatchedMutations = true;
            }

            if (matchedMutation[initVar.name]) {
                var thisMutation = matchedMutation[initVar.name];

                thisMutation.added.concat(nodesAdded);
                thisMutation.removed.concat(nodesRemoved);
                thisMutation.attributes.concat(attributesChanged);
            } else {
                matchedMutation[initVar.name] = {
                    added: nodesAdded,
                    removed: nodesRemoved,
                    attributes: attributesChanged
                };
            }
        });
    });

    if (hasMatchedMutations) {
        var _mutations = new CustomEvent('queried-mutations', {
            detail: matchedMutation
        });
        $window.dispatchEvent(_mutations);
    }
});